<template>
  <div>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="primary"
          fab
          x-small
          depressed
          @click="isOpen = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>
        {{ $t('combos.modals.create.title') }}
      </span>
    </v-tooltip>
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('combos.modals.create.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="newComboForm" v-model="form.valid">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    :label="$t('combos.labels.name')"
                    v-model="form.name"
                    :rules="combo.validation().name"
                    required>
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="closeDialog">
            {{ $t('combos.actions.close') }}
          </v-btn>
          <v-btn
            color="primary"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            {{ $t('combos.actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Combo from '@/models/Combo'

export default {
  props: {
    subrecipe: {
      type: Boolean,
      default: false
    }
  },
  data () {
    let combo = new Combo()

    return {
      overlay: false,
      isOpen: false,
      combo,
      form: {
        name: null,
        restaurant: this.$store.state.currentRestaurant.data._id
      }
    }
  },
  methods: {
    submit: async function () {
      this.$refs.newComboForm.validate()
      if (this.form.valid) {
        this.overlay = true
        this.combo.set(this.form)
        try {
          await this.combo.save()
          this.$emit('created', this.combo)
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    closeDialog () {
      this.$refs.newComboForm.reset()
      this.isOpen = false
      this.form = {
        name: null,
        restaurant: this.$store.state.currentRestaurant.data._id
      }
      this.combo = new Combo()
      this.$emit('close', false)
    }
  }
}
</script>
